import { render, staticRenderFns } from "./eliminado.vue?vue&type=template&id=f67fe4fc&scoped=true"
import script from "./eliminado.vue?vue&type=script&lang=js"
export * from "./eliminado.vue?vue&type=script&lang=js"
import style0 from "./eliminado.vue?vue&type=style&index=0&id=f67fe4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67fe4fc",
  null
  
)

export default component.exports